export const googleProductApiName = 'ProductApi::GoogleProduct';

export const ProductApiNames = [googleProductApiName, 'ProductApi::Csv'];
